import { Stack } from '@veeqo/ui';
import TitleGroup from 'components/common/TitleGroup';
import Layout from 'components/layout/Layout';
import { useAppContext } from 'context/Context';
import { VerifyCodeForm } from './components/LoginVerificationForm';
import LoginAside from './components/LoginAside';
import { Container, FormContainer, Wrapper } from './styled';

export const LoginVerification = () => {
  const {
    state: {
      signupData: { email },
    },
  } = useAppContext();

  return (
    <Layout showLogo showSignup asideContent={<LoginAside />}>
      <Wrapper>
        <Container>
          <TitleGroup
            title="Two-Step Verification"
            subtitle={`Enter the verification code sent to ${email} or shown in your authenticator app.`}
          />
          <Stack spacing={8}>
            <FormContainer>
              <VerifyCodeForm />
            </FormContainer>
          </Stack>
        </Container>
      </Wrapper>
    </Layout>
  );
};
